module.exports = global["$"] = require("-!C:\\PlentyMarkets\\1572\\174\\ZeitloungeTheme\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");